import React, { useEffect, useState } from 'react'
import { SearchPropertiesApi } from '../../apis/SearchPropertiesApi'
import './SelectYourLocation.css'
import { useCookies } from 'react-cookie'
import PropertyCard from './PropertyCard'
import { Icon } from '../../components/gp'

const labelStyle = {
    display: 'block',
    font: 'var(--gp-caption)',
    color: 'var(--gp-ink-mute)',
    marginBottom: 6,
}

const inputRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '12px 14px',
    background: 'var(--gp-card)',
    border: '1px solid var(--gp-hairline)',
    borderRadius: 'var(--gp-r-md)',
}

const inputStyle = {
    flex: 1,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    font: '500 16px/1 var(--gp-mono)',
    color: 'var(--gp-ink)',
    letterSpacing: 2,
}

const PropertySelect = (props) => {
    const [zip, setZip] = useState('')
    const [properties, setProperties] = useState([])
    const [activeSearch, setActiveSearch] = useState(false)
    const [cookies] = useCookies(['propertyUuid'])

    const searchByZip = (zipcode) => {
        setProperties([])
        setActiveSearch(true)
        if (zipcode?.toString().length === 5) {
            SearchPropertiesApi.byZip(zipcode).then((data) => {
                if (data?.properties.length > 0) {
                    setProperties(data.properties)
                }
            })
        } else {
            setActiveSearch(false)
        }
    }

    const getPropertyInfo = (propertyUuid) => {
        SearchPropertiesApi.byId(propertyUuid).then((data) => {
            setProperties([data])
        })
    }

    useEffect(() => {
        if (cookies.propertyUuid) {
            getPropertyInfo(cookies.propertyUuid)
        }
        if (Object.keys(props.selectedProperty || {}).length > 0) {
            setProperties([props.selectedProperty])
        }
    }, [])

    return (
        <div style={{ maxWidth: 560, margin: '0 auto' }}>
            {!cookies.propertyUuid && (
                <div style={{ marginBottom: 18 }}>
                    <label style={labelStyle}>Property zip code</label>
                    <div style={inputRow}>
                        <span style={{ color: 'var(--gp-ink-mute)', display: 'inline-flex' }}>
                            <Icon name="home" size={18} />
                        </span>
                        <input
                            id="zip"
                            value={zip}
                            onChange={(e) => {
                                const next = e.target.value.replace(/\D/g, '').slice(0, 5)
                                setZip(next)
                                searchByZip(next)
                            }}
                            placeholder="94123"
                            inputMode="numeric"
                            style={inputStyle}
                        />
                    </div>
                </div>
            )}

            {activeSearch && properties?.length === 0 && (
                <div
                    style={{
                        background: 'var(--gp-surface)',
                        border: '1px solid var(--gp-hairline)',
                        borderRadius: 'var(--gp-r-md)',
                        padding: '14px 16px',
                        textAlign: 'center',
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-ink-mute)',
                    }}
                >
                    No properties found for that ZIP. Double-check the code, or contact{' '}
                    <a
                        href="mailto:support@gopowerev.com"
                        style={{
                            color: 'var(--gp-brand)',
                            textDecoration: 'none',
                            fontWeight: 500,
                        }}
                    >
                        support@gopowerev.com
                    </a>
                    .
                </div>
            )}

            {properties?.length > 0 && (
                <div
                    style={{
                        background: 'var(--gp-card)',
                        border: '1px solid var(--gp-hairline)',
                        borderRadius: 'var(--gp-r-md)',
                        overflow: 'hidden',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px 16px',
                            borderBottom: '1px solid var(--gp-hairline)',
                            font: '500 11px/1 var(--gp-font)',
                            letterSpacing: 0.6,
                            textTransform: 'uppercase',
                            color: 'var(--gp-ink-mute)',
                            background: 'var(--gp-surface)',
                        }}
                    >
                        <span>
                            {properties.length}{' '}
                            {properties.length === 1 ? 'match found' : 'matches found'}
                        </span>
                        {zip.length === 5 && <span>ZIP {zip}</span>}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {properties.map((property, index) => (
                            <PropertyCard
                                key={property.propertyUUID || index}
                                propertyInfo={property}
                                propertyCardIndex={index}
                                isLast={index === properties.length - 1}
                                selectThisProperty={(info) => props.selectProperty(info)}
                                disableSelect={false}
                            />
                        ))}
                    </div>
                </div>
            )}

            {properties?.length === 0 && !activeSearch && !cookies.propertyUuid && (
                <div
                    style={{
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-ink-mute)',
                        textAlign: 'center',
                        marginTop: 18,
                    }}
                >
                    Don't see your property?{' '}
                    <a
                        href="mailto:support@gopowerev.com"
                        style={{
                            color: 'var(--gp-brand)',
                            textDecoration: 'none',
                            fontWeight: 500,
                        }}
                    >
                        Tell us where you live
                    </a>
                </div>
            )}
        </div>
    )
}

export default PropertySelect
